import { auth, firestore } from 'config/firebase'
import { onAuthStateChanged, signOut } from 'firebase/auth'
import { doc, getDoc } from 'firebase/firestore'
import React, { createContext, useContext, useEffect, useReducer, useState } from 'react'

const Auth = createContext()

const initialState = { user: {}, isAuthenticated: false }
const reducer = (state, { type, payload }) => {
    switch (type) {
        case "USER_LOGGED_IN": return { user: payload.user, isAuthenticated: true }
        case "USER_LOGGED_OUT": return { initialState }
        case "USER_UPDATE_PROFILE": return { ...state, ...payload }
        default: return state
    }
}
export default function AuthContext({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState)
    const [isAppLoading, setIsAppLoading] = useState(false)
    useEffect(() => {
        setIsAppLoading(true)
        onAuthStateChanged(auth, (user) => {
            if (user) {
                readUserProfile(user)
            } else {
                setIsAppLoading(false)
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const readUserProfile = async (userCredential) => {
        const { uid } = userCredential
        try {
            const docRef = doc(firestore, "users", uid);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                let user = docSnap.data()
                dispatch({ type: "USER_LOGGED_IN", payload: { user } })
                return window.toastify("Welcome back ", 'success')
            } else {
                console.log("No such document!");
                return window.toastify("something went wrong while login the user", 'error')
            }
        } catch (error) {
            console.error(error);
            window.toastify("An error occurred during Login. Please try again.", "error")
        } finally {
            setIsAppLoading(false)
        }
    }

    const handleSignOut = () => {
        signOut(auth).then(() => {
            dispatch({ type: "USER_LOGGED_OUT" })
            return window.toastify("user logged out successfull", 'success')
        }).catch((error) => {
            window.toastify("An error occurred during Signout. Please try again.", "error")
        });
    }
    return (
        <Auth.Provider value={{ ...state, dispatch, isAppLoading, handleSignOut }}>{children}</Auth.Provider>
    )
}

export const useAuthContext = () => useContext(Auth)